import React from 'react'
import { FirstSectionCss } from './Dashboard.style';

function FirstSection() {
    return (
        <FirstSectionCss>
            <div className="container">
                <div className="cstm-row">
                    <div className="left-sec">
                        <h1>WELCOME TO THE SHAREKAIRE AFFILIATE PROGRAM!</h1>
                        <p>
                            Kaire treats affiliates as partners. At Kaire, we’re passionate about natural products that transform lives.
                            That’s why we’re excited to share our exceptional range of health and wellness products with you – and the
                            opportunity to share them with others through our Affiliate Program.
                        </p>
                        <p>
                            As a Kaire Affiliate, you’ll earn a generous 20% commission on the first order of every customer you refer and 10% commission on any further orders that customer purchases!*
                        </p>
                        <p>It's a fantastic opportunity to monetize your network, blog, or social media presence, all while
                            promoting products you believe in. </p>
                    </div>
                    <div className="right-sec">
                        <figure>
                            <img src="/images/journey-1.jpg" alt="Image" />
                        </figure>
                    </div>
                </div>
            </div>
        </FirstSectionCss >
    )
}
export default FirstSection;
